import { __makeTemplateObject, __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import styled from 'styled-components';
import { StyledButton } from '../styles/index.js';
import { BaseSocialLoginButtonStyle } from './baseStyle.js';
var KAKAO_THEME_COLOR = {
  BACKGROUND: {
    DEFAULT: '#FFE500',
    HOVER: '#FFEA33',
    PRESSED: '#E5CD00'
  },
  BORDER: 'transparent',
  FONT: '#212529'
};
var KakaoStyledButton = styled(StyledButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  color: ", ";\n\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n\n  color: ", ";\n\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"])), BaseSocialLoginButtonStyle, KAKAO_THEME_COLOR.FONT, KAKAO_THEME_COLOR.BACKGROUND.DEFAULT, KAKAO_THEME_COLOR.BACKGROUND.HOVER, KAKAO_THEME_COLOR.BACKGROUND.PRESSED);

var KakaoLogo = function KakaoLogo() {
  return React.createElement("svg", {
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M11.9998 0C5.37319 0 0 4.21125 0 9.40919C0 12.748 2.22549 15.6795 5.56766 17.3526L4.43697 21.5422C4.3937 21.6708 4.42959 21.807 4.52351 21.8997C4.58817 21.9644 4.67447 22 4.76814 22C4.84042 22 4.91221 21.9714 4.97712 21.9214L9.83892 18.661C10.545 18.761 11.2654 18.8181 11.9998 18.8181C18.6263 18.8181 24 14.6071 24 9.40919C24 4.21125 18.6263 0 11.9998 0Z",
    fill: "#3C1E1E"
  }));
};

function KakaoButton(_a) {
  _a.size;

  var children = _a.children,
      _c = _a.platform,
      platform = _c === void 0 ? 'desktop' : _c,
      props = __rest(_a, ["size", "children", "platform"]);

  return React.createElement(KakaoStyledButton, __assign({}, props, {
    size: platform === 'desktop' ? 'large' : 'medium'
  }), React.createElement(KakaoLogo, null), children);
}

var templateObject_1;
export { KakaoButton as default };